/* THIS FILE IS GENERATED BY DataGridTypeScriptGenerator. */
import { defineDataGridContract } from './lib/contract'
import type { DataGridQuery, DataGridResponse } from './lib/types'

export type AgentPsksGridValues = {
  "pskId": string
  "keyHash": string
  "createdAt": string
  "usedCount": number
  "maxUsages": number | null
  "expiresAt": string | null
  "status": string
}
export const agentPsksGridContract = defineDataGridContract<AgentPsksGridValues>()({
  "id": "agent-psks",
  "keyColumn": "pskId",
  "searchMinimumLength": 3,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "createdAt",
      "direction": "desc"
    }
  ],
  "columns": {
    "pskId": {
      "id": "pskId",
      "label": "PSK ID",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "keyHash": {
      "id": "keyHash",
      "label": "Key",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "createdAt": {
      "id": "createdAt",
      "label": "Created",
      "kind": "timestamp",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "before",
        "after",
        "between",
        "relative",
        "age",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "usedCount": {
      "id": "usedCount",
      "label": "Used",
      "kind": "number",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "atLeast",
        "atMost",
        "between"
      ],
      "labels": null,
      "field": null
    },
    "maxUsages": {
      "id": "maxUsages",
      "label": "Limit",
      "kind": "number",
      "nullable": true,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "atLeast",
        "atMost",
        "between",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "expiresAt": {
      "id": "expiresAt",
      "label": "Expires",
      "kind": "timestamp",
      "nullable": true,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "before",
        "after",
        "between",
        "relative",
        "age",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "status": {
      "id": "status",
      "label": "Status",
      "kind": "category",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "in"
      ],
      "labels": null,
      "field": null
    }
  }
} as const)
export type AgentPsksGridQuery = DataGridQuery<typeof agentPsksGridContract>
export type AgentPsksGridResponse = DataGridResponse<typeof agentPsksGridContract>

export type AgentsGridValues = {
  "agentId": string
  "name": string
  "entity": string
  "entityId": string
  "ipAddress": string | null
  "os": string | null
  "chassis": string | null
  "status": "Online" | "Offline" | "Revoked"
  "agentVersion": string | null
  "osVersion": string | null
  "architecture": string | null
  "lastOnlineAt": string
  "revokedAt": string | null
  "goos": string | null
}
export const agentsGridContract = defineDataGridContract<AgentsGridValues>()({
  "id": "agents",
  "keyColumn": "agentId",
  "searchMinimumLength": 3,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "lastOnlineAt",
      "direction": "desc"
    }
  ],
  "columns": {
    "agentId": {
      "id": "agentId",
      "label": "Agent ID",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "name": {
      "id": "name",
      "label": "Agent",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "entity": {
      "id": "entity",
      "label": "Entity",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "entityId": {
      "id": "entityId",
      "label": "Entity id",
      "kind": "value",
      "nullable": false,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "ipAddress": {
      "id": "ipAddress",
      "label": "IP address",
      "kind": "text",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "os": {
      "id": "os",
      "label": "OS",
      "kind": "text",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "chassis": {
      "id": "chassis",
      "label": "Device",
      "kind": "category",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "status": {
      "id": "status",
      "label": "Status",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "in"
      ],
      "labels": {
        "Online": "Online",
        "Offline": "Offline",
        "Revoked": "Revoked"
      },
      "field": null
    },
    "agentVersion": {
      "id": "agentVersion",
      "label": "Agent version",
      "kind": "category",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "osVersion": {
      "id": "osVersion",
      "label": "OS version",
      "kind": "text",
      "nullable": true,
      "searchable": true,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "architecture": {
      "id": "architecture",
      "label": "Architecture",
      "kind": "category",
      "nullable": true,
      "searchable": true,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [
        "in",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "lastOnlineAt": {
      "id": "lastOnlineAt",
      "label": "Last online at",
      "kind": "timestamp",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "revokedAt": {
      "id": "revokedAt",
      "label": "Revoked at",
      "kind": "timestamp",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    }
  },
  "supportingValues": {
    "goos": {
      "kind": "text",
      "nullable": true
    }
  },
  "parameters": {
    "includeDescendants": {
      "type": "boolean",
      "default": true,
      "id": "includeDescendants",
      "label": "Include children"
    }
  }
} as const)
export type AgentsGridQuery = DataGridQuery<typeof agentsGridContract>
export type AgentsGridResponse = DataGridResponse<typeof agentsGridContract>

export type AssetsGridValues = {
  "assetId": string
  "name": string
  "entity": string
  "entityId": string
  "deviceClass": string
  "manufacturer": string | null
  "model": string | null
  "serialNumber": string | null
  "ipAddress": string | null
  "macAddress": string | null
  "sourceAgent": string | null
  "blackSupplyLevel": number | null
  "cyanSupplyLevel": number | null
  "magentaSupplyLevel": number | null
  "yellowSupplyLevel": number | null
  "totalPageCount": number | null
  "lastMeterReadAt": string | null
  "reachability": string
  "posture": { "backupProducts": Array<string> | null; "encryptedVolumes": number | null; "firewallEnabled": boolean | null; "localAdministrators": number | null; "mdmEnrolled": boolean | null; "missingUpdates": number | null; "protectionProducts": Array<string> | null; "remoteManagementProducts": Array<string> | null; "totalVolumes": number | null }
  "lastSeenAt": string | null
  "lastKnownNameAt": string | null
  "lastKnownManufacturerAt": string | null
  "lastKnownModelAt": string | null
  "lastKnownSerialAt": string | null
  "sourceAgentId": string | null
}
export const assetsGridContract = defineDataGridContract<AssetsGridValues>()({
  "id": "assets",
  "keyColumn": "assetId",
  "searchMinimumLength": 3,
  "searchMode": "fuzzy",
  "defaultSort": [
    {
      "column": "lastSeenAt",
      "direction": "desc"
    }
  ],
  "columns": {
    "assetId": {
      "id": "assetId",
      "label": "Asset id",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "name": {
      "id": "name",
      "label": "Asset",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "entity": {
      "id": "entity",
      "label": "Entity",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "entityId": {
      "id": "entityId",
      "label": "Entity id",
      "kind": "value",
      "nullable": false,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "deviceClass": {
      "id": "deviceClass",
      "label": "Device type",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "in"
      ],
      "labels": {
        "computer": "Computer",
        "workstation": "Workstation",
        "printer": "Printer",
        "network_printer": "Network printer",
        "router": "Router",
        "network_device": "Network device",
        "switch": "Switch",
        "access_point": "Access point",
        "nas": "NAS",
        "unknown": "Unknown"
      },
      "field": null
    },
    "manufacturer": {
      "id": "manufacturer",
      "label": "Manufacturer",
      "kind": "category",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "model": {
      "id": "model",
      "label": "Model",
      "kind": "text",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "serialNumber": {
      "id": "serialNumber",
      "label": "Serial number",
      "kind": "text",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "ipAddress": {
      "id": "ipAddress",
      "label": "IP address",
      "kind": "text",
      "nullable": true,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "macAddress": {
      "id": "macAddress",
      "label": "MAC address",
      "kind": "text",
      "nullable": true,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "sourceAgent": {
      "id": "sourceAgent",
      "label": "Source agent",
      "kind": "text",
      "nullable": true,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "blackSupplyLevel": {
      "id": "blackSupplyLevel",
      "label": "Black supply",
      "kind": "number",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "cyanSupplyLevel": {
      "id": "cyanSupplyLevel",
      "label": "Cyan supply",
      "kind": "number",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "magentaSupplyLevel": {
      "id": "magentaSupplyLevel",
      "label": "Magenta supply",
      "kind": "number",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "yellowSupplyLevel": {
      "id": "yellowSupplyLevel",
      "label": "Yellow supply",
      "kind": "number",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "totalPageCount": {
      "id": "totalPageCount",
      "label": "Total page count",
      "kind": "value",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "lastMeterReadAt": {
      "id": "lastMeterReadAt",
      "label": "Last meter read",
      "kind": "timestamp",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "reachability": {
      "id": "reachability",
      "label": "Reachability",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [
        "in"
      ],
      "labels": {
        "reachable": "Reachable",
        "unreachable": "Unreachable",
        "stale": "Stale",
        "unknown": "Unknown"
      },
      "field": null
    },
    "posture": {
      "id": "posture",
      "label": "Posture",
      "kind": "value",
      "nullable": false,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "lastSeenAt": {
      "id": "lastSeenAt",
      "label": "Last seen",
      "kind": "timestamp",
      "nullable": true,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "before",
        "after",
        "between",
        "relative",
        "age",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "lastKnownNameAt": {
      "id": "lastKnownNameAt",
      "label": "Last known name at",
      "kind": "timestamp",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "lastKnownManufacturerAt": {
      "id": "lastKnownManufacturerAt",
      "label": "Last known manufacturer at",
      "kind": "timestamp",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "lastKnownModelAt": {
      "id": "lastKnownModelAt",
      "label": "Last known model at",
      "kind": "timestamp",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "lastKnownSerialAt": {
      "id": "lastKnownSerialAt",
      "label": "Serial last confirmed at",
      "kind": "timestamp",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    }
  },
  "supportingValues": {
    "sourceAgentId": {
      "kind": "value",
      "nullable": true
    }
  },
  "parameters": {
    "includeDescendants": {
      "type": "boolean",
      "default": true,
      "id": "includeDescendants",
      "label": "Include children"
    }
  }
} as const)
export type AssetsGridQuery = DataGridQuery<typeof assetsGridContract>
export type AssetsGridResponse = DataGridResponse<typeof assetsGridContract>

export type AuditLogGridValues = {
  "id": string
  "timestamp": string
  "action": string
  "subjectType": string
  "entity": string | null
  "details": string
  "actor": string
  "entityId": string | null
  "origin": string | null
  "initiatedBy": string | null
}
export const auditLogGridContract = defineDataGridContract<AuditLogGridValues>()({
  "id": "audit-log",
  "keyColumn": "id",
  "searchMinimumLength": 3,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "timestamp",
      "direction": "desc"
    }
  ],
  "columns": {
    "id": {
      "id": "id",
      "label": "Id",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "timestamp": {
      "id": "timestamp",
      "label": "Time",
      "kind": "timestamp",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "before",
        "after",
        "between",
        "relative",
        "age",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "action": {
      "id": "action",
      "label": "Action",
      "kind": "category",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in"
      ],
      "labels": {
        "CREATE": "Created",
        "UPDATE": "Updated",
        "USER_DEACTIVATED": "Deactivated",
        "USER_REACTIVATED": "Reactivated",
        "DELETE": "Deleted",
        "CONFIG_CHANGE": "Configuration changed",
        "MEMBERSHIP_ADDED": "Added to group",
        "MEMBERSHIP_REMOVED": "Removed from group",
        "EXPORT": "Data exported",
        "PSK_ISSUED": "Agent key issued",
        "PSK_REVOKED": "Agent key revoked",
        "AGENT_REVOKED": "Agent revoked",
        "SECRET_CREATED": "Secret created",
        "SECRET_DELETED": "Secret deleted",
        "SIGN_OUT": "Everyone signed out",
        "CONSENT_GRANTED": "Consent granted",
        "CONSENT_REVOKED": "Consent revoked",
        "AGENT_MOVED": "Agent moved",
        "AGENT_COMMAND_DISPATCHED": "Agent command dispatched",
        "SETTING_EFFECTIVE_CHANGED": "Effective setting changed",
        "PERMISSION_CHANGE": "Permission changed",
        "SNMP_CONFIGURATION_CHANGED": "SNMP configuration changed",
        "LOGIN_SUCCEEDED": "Logged in",
        "LOGIN_FAILED": "Login failed",
        "VIEW": "Viewed",
        "IMPERSONATION_START": "Impersonation started",
        "IMPERSONATION_END": "Impersonation ended",
        "OUT_OF_BAND_CHANGE": "Out-of-band change",
        "BROADCAST": "Broadcast sent",
        "LINK": "Linked",
        "ALERT_RULE_CREATED": "Alert rule created",
        "ALERT_RULE_UPDATED": "Alert rule updated",
        "ALERT_RULE_COPIED": "Alert rule copied",
        "ALERT_RULE_DELETED": "Alert rule deleted",
        "POLICY_CREATED": "Policy created",
        "POLICY_UPDATED": "Policy updated",
        "POLICY_DELETED": "Policy deleted",
        "CLASSIFICATION_CATALOG_CREATED": "Classification catalog created",
        "CLASSIFICATION_CATALOG_UPDATED": "Classification catalog updated"
      },
      "field": null
    },
    "subjectType": {
      "id": "subjectType",
      "label": "Type",
      "kind": "category",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in"
      ],
      "labels": {
        "Entity": "Entity",
        "Setting": "Setting",
        "WhitelabelLogo": "Brand logo",
        "EntityResourceSetting": "Resource default",
        "ResourceSetting": "Resource setting",
        "CustomField": "Custom field",
        "Group": "Group",
        "User": "User",
        "AuditLog": "Audit log",
        "DataGrid": "Data grid",
        "Agent": "Agent",
        "DiagnosticBundle": "Diagnostic bundle",
        "ContentGroup": "Content group",
        "AgentPsk": "Agent key",
        "AssistantControl": "AI control",
        "IdentityProvider": "Identity provider",
        "MachineAccount": "Machine account",
        "OAuthApplication": "OAuth application",
        "Role": "Role",
        "AgentConfiguration": "Agent configuration",
        "ContentItem": "Content item",
        "ContentMedia": "Content media",
        "AccountAuditLog": "Account audit log",
        "Asset": "Asset"
      },
      "field": null
    },
    "entity": {
      "id": "entity",
      "label": "Entity",
      "kind": "text",
      "nullable": true,
      "searchable": true,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "details": {
      "id": "details",
      "label": "Details",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "actor": {
      "id": "actor",
      "label": "Actor",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "entityId": {
      "id": "entityId",
      "label": "Entity id",
      "kind": "value",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "origin": {
      "id": "origin",
      "label": "Origin",
      "kind": "text",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "initiatedBy": {
      "id": "initiatedBy",
      "label": "Initiated By",
      "kind": "text",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    }
  },
  "parameters": {
    "includeDescendants": {
      "type": "boolean",
      "default": true,
      "id": "includeDescendants",
      "label": "Include children"
    },
    "includeDerived": {
      "type": "boolean",
      "default": false,
      "id": "includeDerived",
      "label": "Include derived changes"
    }
  }
} as const)
export type AuditLogGridQuery = DataGridQuery<typeof auditLogGridContract>
export type AuditLogGridResponse = DataGridResponse<typeof auditLogGridContract>

export type ClassificationCatalogEntriesGridValues = {
  "key": string
  "title": string
  "summary": string
  "field": string | null
  "entryType": string
  "position": number | null
  "ordinal": number | null
  "childCount": number
  "matchingChildCount": number
  "evaluation": string | null
  "ifMissing": string | null
  "stopsWithoutValue": string | null
  "manufacturers": string | null
  "inputs": string | null
}
export const classificationCatalogEntriesGridContract = defineDataGridContract<ClassificationCatalogEntriesGridValues>()({
  "id": "classification-catalog-entries",
  "keyColumn": "key",
  "searchMinimumLength": 3,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "position",
      "direction": "asc"
    }
  ],
  "columns": {
    "key": {
      "id": "key",
      "label": "Entry key",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "title": {
      "id": "title",
      "label": "Rule",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "summary": {
      "id": "summary",
      "label": "What it does",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "field": {
      "id": "field",
      "label": "Field",
      "kind": "category",
      "nullable": true,
      "searchable": true,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "entryType": {
      "id": "entryType",
      "label": "Entry type",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [
        "in",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "position": {
      "id": "position",
      "label": "Release position",
      "kind": "number",
      "nullable": true,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "ordinal": {
      "id": "ordinal",
      "label": "Evaluation order",
      "kind": "number",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "childCount": {
      "id": "childCount",
      "label": "Total children",
      "kind": "number",
      "nullable": false,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "matchingChildCount": {
      "id": "matchingChildCount",
      "label": "Matching children",
      "kind": "number",
      "nullable": false,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "evaluation": {
      "id": "evaluation",
      "label": "Evaluation",
      "kind": "category",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [
        "in",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "ifMissing": {
      "id": "ifMissing",
      "label": "If missing",
      "kind": "category",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [
        "in",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "stopsWithoutValue": {
      "id": "stopsWithoutValue",
      "label": "Stops without a value",
      "kind": "category",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [
        "in",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "manufacturers": {
      "id": "manufacturers",
      "label": "Manufacturers",
      "kind": "text",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "inputs": {
      "id": "inputs",
      "label": "Inputs",
      "kind": "text",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    }
  }
} as const)
export type ClassificationCatalogEntriesGridQuery = DataGridQuery<typeof classificationCatalogEntriesGridContract>
export type ClassificationCatalogEntriesGridResponse = DataGridResponse<typeof classificationCatalogEntriesGridContract>

export type ClassificationCatalogGroupEntriesGridValues = {
  "key": string
  "title": string
  "summary": string
  "field": string | null
  "entryType": string
  "position": number | null
  "ordinal": number | null
  "childCount": number
  "matchingChildCount": number
  "evaluation": string | null
  "ifMissing": string | null
  "stopsWithoutValue": string | null
  "manufacturers": string | null
  "inputs": string | null
}
export const classificationCatalogGroupEntriesGridContract = defineDataGridContract<ClassificationCatalogGroupEntriesGridValues>()({
  "id": "classification-catalog-group-entries",
  "keyColumn": "key",
  "searchMinimumLength": 3,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "position",
      "direction": "asc"
    }
  ],
  "columns": {
    "key": {
      "id": "key",
      "label": "Entry key",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "title": {
      "id": "title",
      "label": "Rule",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "summary": {
      "id": "summary",
      "label": "What it does",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "field": {
      "id": "field",
      "label": "Field",
      "kind": "category",
      "nullable": true,
      "searchable": true,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "entryType": {
      "id": "entryType",
      "label": "Entry type",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [
        "in",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "position": {
      "id": "position",
      "label": "Release position",
      "kind": "number",
      "nullable": true,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "ordinal": {
      "id": "ordinal",
      "label": "Evaluation order",
      "kind": "number",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "childCount": {
      "id": "childCount",
      "label": "Total children",
      "kind": "number",
      "nullable": false,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "matchingChildCount": {
      "id": "matchingChildCount",
      "label": "Matching children",
      "kind": "number",
      "nullable": false,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "evaluation": {
      "id": "evaluation",
      "label": "Evaluation",
      "kind": "category",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [
        "in",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "ifMissing": {
      "id": "ifMissing",
      "label": "If missing",
      "kind": "category",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [
        "in",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "stopsWithoutValue": {
      "id": "stopsWithoutValue",
      "label": "Stops without a value",
      "kind": "category",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [
        "in",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "manufacturers": {
      "id": "manufacturers",
      "label": "Manufacturers",
      "kind": "text",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "inputs": {
      "id": "inputs",
      "label": "Inputs",
      "kind": "text",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    }
  }
} as const)
export type ClassificationCatalogGroupEntriesGridQuery = DataGridQuery<typeof classificationCatalogGroupEntriesGridContract>
export type ClassificationCatalogGroupEntriesGridResponse = DataGridResponse<typeof classificationCatalogGroupEntriesGridContract>

export type ClassificationCatalogReleasesGridValues = {
  "releaseKey": string
  "version": number
  "state": string
  "activation": "Active" | "Inactive"
  "createdAt": string
}
export const classificationCatalogReleasesGridContract = defineDataGridContract<ClassificationCatalogReleasesGridValues>()({
  "id": "classification-catalog-releases",
  "keyColumn": "releaseKey",
  "searchMinimumLength": 1,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "version",
      "direction": "desc"
    }
  ],
  "columns": {
    "releaseKey": {
      "id": "releaseKey",
      "label": "Release key",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "version": {
      "id": "version",
      "label": "Version",
      "kind": "number",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "atLeast",
        "atMost",
        "between",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "state": {
      "id": "state",
      "label": "State",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "in"
      ],
      "labels": {
        "draft": "Draft",
        "approved": "Approved",
        "published": "Published",
        "withdrawn": "Withdrawn",
        "rejected": "Rejected"
      },
      "field": null
    },
    "activation": {
      "id": "activation",
      "label": "Active",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [
        "in"
      ],
      "labels": {
        "Active": "Active",
        "Inactive": "Not active"
      },
      "field": null
    },
    "createdAt": {
      "id": "createdAt",
      "label": "Created",
      "kind": "timestamp",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "before",
        "after",
        "between",
        "relative",
        "age",
        "empty"
      ],
      "labels": null,
      "field": null
    }
  }
} as const)
export type ClassificationCatalogReleasesGridQuery = DataGridQuery<typeof classificationCatalogReleasesGridContract>
export type ClassificationCatalogReleasesGridResponse = DataGridResponse<typeof classificationCatalogReleasesGridContract>

export type ContentDocumentsGridValues = {
  "contentItemId": string
  "title": string
  "slug": string
  "status": string
  "pendingDraft": string
  "audience": string
  "group": string | null
  "sortOrder": number
  "updatedAt": string
}
export const contentDocumentsGridContract = defineDataGridContract<ContentDocumentsGridValues>()({
  "id": "content-documents",
  "keyColumn": "contentItemId",
  "searchMinimumLength": 1,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "sortOrder",
      "direction": "asc"
    }
  ],
  "columns": {
    "contentItemId": {
      "id": "contentItemId",
      "label": "Document ID",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "title": {
      "id": "title",
      "label": "Title",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "slug": {
      "id": "slug",
      "label": "Slug",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "status": {
      "id": "status",
      "label": "Status",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "in"
      ],
      "labels": {
        "draft": "Draft",
        "published": "Published"
      },
      "field": null
    },
    "pendingDraft": {
      "id": "pendingDraft",
      "label": "Pending draft",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [
        "in"
      ],
      "labels": {
        "none": "None",
        "pending": "Pending"
      },
      "field": null
    },
    "audience": {
      "id": "audience",
      "label": "Audience",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [
        "in"
      ],
      "labels": {
        "entity": "Entity",
        "descendants": "Shared down"
      },
      "field": null
    },
    "group": {
      "id": "group",
      "label": "Group",
      "kind": "category",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in",
        "empty"
      ],
      "labels": {},
      "field": null
    },
    "sortOrder": {
      "id": "sortOrder",
      "label": "Order",
      "kind": "number",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "atLeast",
        "atMost",
        "between",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "updatedAt": {
      "id": "updatedAt",
      "label": "Updated at",
      "kind": "timestamp",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "before",
        "after",
        "between",
        "relative",
        "age",
        "empty"
      ],
      "labels": null,
      "field": null
    }
  }
} as const)
export type ContentDocumentsGridQuery = DataGridQuery<typeof contentDocumentsGridContract>
export type ContentDocumentsGridResponse = DataGridResponse<typeof contentDocumentsGridContract>

export type FirewallRulesGridValues = {
  "ruleId": string
  "name": string
  "direction": string
  "state": string
  "action": string
  "domain": "Yes" | "No" | null
  "private": "Yes" | "No" | null
  "public": "Yes" | "No" | null
  "protocol": string | null
  "localPorts": string | null
  "group": string | null
  "application": string | null
  "service": string | null
  "rule": { "action": number | null; "application": string | null; "authentication": number | null; "description": string | null; "direction": number | null; "displayGroup": string | null; "displayName": string | null; "dynamicTransport": number | null; "edgeTraversalPolicy": number | null; "enabled": number | null; "encryption": number | null; "group": string | null; "icmpTypesAndCodes": Array<string> | null; "interfaceAliases": Array<string> | null; "interfaceTypes": number | null; "localAddresses": Array<string> | null; "localOnlyMapping": boolean | null; "localPorts": Array<string> | null; "localUser": string | null; "looseSourceMapping": boolean | null; "overrideBlockRules": boolean | null; "owner": string | null; "package": string | null; "platforms": Array<string> | null; "policyStoreSource": string | null; "policyStoreSourceType": number | null; "profiles": number | null; "protocol": string | null; "remoteAddresses": Array<string> | null; "remoteMachine": string | null; "remotePorts": Array<string> | null; "remoteUser": string | null; "ruleId": string; "service": string | null }
}
export const firewallRulesGridContract = defineDataGridContract<FirewallRulesGridValues>()({
  "id": "firewall-rules",
  "keyColumn": "ruleId",
  "searchMinimumLength": 3,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "name",
      "direction": "asc"
    }
  ],
  "columns": {
    "ruleId": {
      "id": "ruleId",
      "label": "Rule ID",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "name": {
      "id": "name",
      "label": "Rule name",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "direction": {
      "id": "direction",
      "label": "Direction",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in"
      ],
      "labels": null,
      "field": null
    },
    "state": {
      "id": "state",
      "label": "State",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in"
      ],
      "labels": null,
      "field": null
    },
    "action": {
      "id": "action",
      "label": "Action",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in"
      ],
      "labels": null,
      "field": null
    },
    "domain": {
      "id": "domain",
      "label": "Domain",
      "kind": "category",
      "nullable": true,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in"
      ],
      "labels": {
        "Yes": "Yes",
        "No": "No"
      },
      "field": null
    },
    "private": {
      "id": "private",
      "label": "Private",
      "kind": "category",
      "nullable": true,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in"
      ],
      "labels": {
        "Yes": "Yes",
        "No": "No"
      },
      "field": null
    },
    "public": {
      "id": "public",
      "label": "Public",
      "kind": "category",
      "nullable": true,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in"
      ],
      "labels": {
        "Yes": "Yes",
        "No": "No"
      },
      "field": null
    },
    "protocol": {
      "id": "protocol",
      "label": "Protocol",
      "kind": "text",
      "nullable": true,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "localPorts": {
      "id": "localPorts",
      "label": "Local ports",
      "kind": "text",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "group": {
      "id": "group",
      "label": "Group",
      "kind": "text",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "application": {
      "id": "application",
      "label": "Application",
      "kind": "text",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "service": {
      "id": "service",
      "label": "Service",
      "kind": "text",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "rule": {
      "id": "rule",
      "label": "Rule",
      "kind": "value",
      "nullable": false,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    }
  }
} as const)
export type FirewallRulesGridQuery = DataGridQuery<typeof firewallRulesGridContract>
export type FirewallRulesGridResponse = DataGridResponse<typeof firewallRulesGridContract>

export type GroupMembersGridValues = {
  "userId": string
  "name": string
  "email": string | null
  "authoritiesJson": string
}
export const groupMembersGridContract = defineDataGridContract<GroupMembersGridValues>()({
  "id": "group-members",
  "keyColumn": "userId",
  "searchMinimumLength": 3,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "name",
      "direction": "asc"
    }
  ],
  "columns": {
    "userId": {
      "id": "userId",
      "label": "User ID",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "name": {
      "id": "name",
      "label": "Name",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "email": {
      "id": "email",
      "label": "Email",
      "kind": "text",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    }
  },
  "supportingValues": {
    "authoritiesJson": {
      "kind": "text",
      "nullable": false
    }
  }
} as const)
export type GroupMembersGridQuery = DataGridQuery<typeof groupMembersGridContract>
export type GroupMembersGridResponse = DataGridResponse<typeof groupMembersGridContract>

export type GroupsGridValues = {
  "rowKey": string
  "name": string
  "source": string
  "status": string
  "inheritedFrom": string | null
  "roles": string
  "members": number
  "groupId": string
  "inheritedFromEntityId": string | null
  "rolesJson": string
}
export const groupsGridContract = defineDataGridContract<GroupsGridValues>()({
  "id": "groups",
  "keyColumn": "rowKey",
  "searchMinimumLength": 3,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "name",
      "direction": "asc"
    }
  ],
  "columns": {
    "rowKey": {
      "id": "rowKey",
      "label": "Row key",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "name": {
      "id": "name",
      "label": "Name",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "source": {
      "id": "source",
      "label": "Source",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in"
      ],
      "labels": {
        "manual": "Manual",
        "scim": "SCIM"
      },
      "field": null
    },
    "status": {
      "id": "status",
      "label": "Status",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in"
      ],
      "labels": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "field": null
    },
    "inheritedFrom": {
      "id": "inheritedFrom",
      "label": "Inherited from",
      "kind": "text",
      "nullable": true,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "roles": {
      "id": "roles",
      "label": "Roles granted",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "members": {
      "id": "members",
      "label": "Members",
      "kind": "number",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "atLeast",
        "atMost",
        "between",
        "empty"
      ],
      "labels": null,
      "field": null
    }
  },
  "supportingValues": {
    "groupId": {
      "kind": "value",
      "nullable": false
    },
    "inheritedFromEntityId": {
      "kind": "value",
      "nullable": true
    },
    "rolesJson": {
      "kind": "text",
      "nullable": false
    }
  }
} as const)
export type GroupsGridQuery = DataGridQuery<typeof groupsGridContract>
export type GroupsGridResponse = DataGridResponse<typeof groupsGridContract>

export type InvitationsGridValues = {
  "invitationId": string
  "invitedEmail": string
  "lastSentAt": string
  "expiresAt": string
  "status": "Pending" | "AccessFailed"
  "createdAt": string
  "lastAcceptanceErrorDetail": string | null
  "lastAcceptanceFailedAt": string | null
  "manageable": boolean
}
export const invitationsGridContract = defineDataGridContract<InvitationsGridValues>()({
  "id": "invitations",
  "keyColumn": "invitationId",
  "searchMinimumLength": 3,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "createdAt",
      "direction": "asc"
    }
  ],
  "columns": {
    "invitationId": {
      "id": "invitationId",
      "label": "Invitation ID",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "invitedEmail": {
      "id": "invitedEmail",
      "label": "Email",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "lastSentAt": {
      "id": "lastSentAt",
      "label": "Sent",
      "kind": "timestamp",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "before",
        "after",
        "between",
        "relative",
        "age",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "expiresAt": {
      "id": "expiresAt",
      "label": "Expires",
      "kind": "timestamp",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "before",
        "after",
        "between",
        "relative",
        "age",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "status": {
      "id": "status",
      "label": "Status",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "in"
      ],
      "labels": {
        "Pending": "Pending",
        "AccessFailed": "Access failed"
      },
      "field": null
    },
    "createdAt": {
      "id": "createdAt",
      "label": "Created",
      "kind": "timestamp",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [
        "before",
        "after",
        "between",
        "relative",
        "age",
        "empty"
      ],
      "labels": null,
      "field": null
    }
  },
  "supportingValues": {
    "lastAcceptanceErrorDetail": {
      "kind": "text",
      "nullable": true
    },
    "lastAcceptanceFailedAt": {
      "kind": "timestamp",
      "nullable": true
    },
    "manageable": {
      "kind": "value",
      "nullable": false
    }
  }
} as const)
export type InvitationsGridQuery = DataGridQuery<typeof invitationsGridContract>
export type InvitationsGridResponse = DataGridResponse<typeof invitationsGridContract>

export type OauthApplicationsGridValues = {
  "applicationId": string
  "name": string
  "status": string
  "clientId": string
  "callbackUrlCount": number
  "createdBy": string | null
  "createdAt": string
  "updatedAt": string
}
export const oauthApplicationsGridContract = defineDataGridContract<OauthApplicationsGridValues>()({
  "id": "oauth-applications",
  "keyColumn": "applicationId",
  "searchMinimumLength": 3,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "name",
      "direction": "asc"
    }
  ],
  "columns": {
    "applicationId": {
      "id": "applicationId",
      "label": "Application ID",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "name": {
      "id": "name",
      "label": "Name",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "status": {
      "id": "status",
      "label": "Status",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in"
      ],
      "labels": {
        "active": "Active",
        "needs-callback-url": "Needs a callback URL"
      },
      "field": null
    },
    "clientId": {
      "id": "clientId",
      "label": "Client ID",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "callbackUrlCount": {
      "id": "callbackUrlCount",
      "label": "Callback URLs",
      "kind": "number",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "createdBy": {
      "id": "createdBy",
      "label": "Created by",
      "kind": "text",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "createdAt": {
      "id": "createdAt",
      "label": "Created",
      "kind": "timestamp",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "before",
        "after",
        "between",
        "relative",
        "age",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "updatedAt": {
      "id": "updatedAt",
      "label": "Last updated",
      "kind": "timestamp",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [
        "before",
        "after",
        "between",
        "relative",
        "age",
        "empty"
      ],
      "labels": null,
      "field": null
    }
  }
} as const)
export type OauthApplicationsGridQuery = DataGridQuery<typeof oauthApplicationsGridContract>
export type OauthApplicationsGridResponse = DataGridResponse<typeof oauthApplicationsGridContract>

export type PackageSourceEventsGridValues = {
  "receiptId": string
  "receivedAt": string
  "version": string
  "builds": string | null
  "result": "Processing" | "Completed" | "Failed"
  "reason": string | null
  "submissionId": string
}
export const packageSourceEventsGridContract = defineDataGridContract<PackageSourceEventsGridValues>()({
  "id": "package-source-events",
  "keyColumn": "receiptId",
  "searchMinimumLength": 3,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "receivedAt",
      "direction": "desc"
    }
  ],
  "columns": {
    "receiptId": {
      "id": "receiptId",
      "label": "Receipt ID",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "receivedAt": {
      "id": "receivedAt",
      "label": "Received",
      "kind": "timestamp",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "before",
        "after",
        "between",
        "relative",
        "age",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "version": {
      "id": "version",
      "label": "Version",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "builds": {
      "id": "builds",
      "label": "Builds",
      "kind": "text",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "result": {
      "id": "result",
      "label": "Result",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "in"
      ],
      "labels": {
        "Processing": "Processing",
        "Completed": "Completed",
        "Failed": "Failed"
      },
      "field": null
    },
    "reason": {
      "id": "reason",
      "label": "Reason",
      "kind": "category",
      "nullable": true,
      "searchable": false,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [
        "in"
      ],
      "labels": {
        "IMMUTABLE_REVISION_CONFLICT": "Version conflict",
        "ARTIFACT_VERIFICATION_FAILED": "Files need attention",
        "SOURCE_ACCESS_REVOKED": "Access needs attention",
        "INVALID_SOURCE_MANIFEST": "Submission needs attention",
        "SAVED_AUDIENCE_UNAVAILABLE": "Audience unavailable",
        "PACKAGE_SERVICE_UNAVAILABLE": "Temporarily unavailable"
      },
      "field": null
    },
    "submissionId": {
      "id": "submissionId",
      "label": "Submission ID",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    }
  }
} as const)
export type PackageSourceEventsGridQuery = DataGridQuery<typeof packageSourceEventsGridContract>
export type PackageSourceEventsGridResponse = DataGridResponse<typeof packageSourceEventsGridContract>

export type PackageSourcesGridValues = {
  "sourceId": string
  "name": string
  "packageType": string
  "packageId": string
  "status": "Enabled" | "Paused"
  "delivery": "Rollout" | "Library"
  "revision": number
  "createdAt": string
}
export const packageSourcesGridContract = defineDataGridContract<PackageSourcesGridValues>()({
  "id": "package-sources",
  "keyColumn": "sourceId",
  "searchMinimumLength": 3,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "name",
      "direction": "asc"
    }
  ],
  "columns": {
    "sourceId": {
      "id": "sourceId",
      "label": "Source ID",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "name": {
      "id": "name",
      "label": "Name",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "packageType": {
      "id": "packageType",
      "label": "Package type",
      "kind": "category",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in"
      ],
      "labels": null,
      "field": null
    },
    "packageId": {
      "id": "packageId",
      "label": "Package ID",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "status": {
      "id": "status",
      "label": "Status",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "in"
      ],
      "labels": {
        "Enabled": "Enabled",
        "Paused": "Submissions paused"
      },
      "field": null
    },
    "delivery": {
      "id": "delivery",
      "label": "Delivery",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "in"
      ],
      "labels": {
        "Rollout": "Prepare a rollout",
        "Library": "Add to library only"
      },
      "field": null
    },
    "revision": {
      "id": "revision",
      "label": "Revision",
      "kind": "value",
      "nullable": false,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "createdAt": {
      "id": "createdAt",
      "label": "Created",
      "kind": "timestamp",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "before",
        "after",
        "between",
        "relative",
        "age",
        "empty"
      ],
      "labels": null,
      "field": null
    }
  }
} as const)
export type PackageSourcesGridQuery = DataGridQuery<typeof packageSourcesGridContract>
export type PackageSourcesGridResponse = DataGridResponse<typeof packageSourcesGridContract>

export type PendingUsersGridValues = {
  "userId": string
  "name": string
  "email": string | null
  "source": string
  "createdAt": string
}
export const pendingUsersGridContract = defineDataGridContract<PendingUsersGridValues>()({
  "id": "pending-users",
  "keyColumn": "userId",
  "searchMinimumLength": 3,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "createdAt",
      "direction": "asc"
    }
  ],
  "columns": {
    "userId": {
      "id": "userId",
      "label": "User ID",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "name": {
      "id": "name",
      "label": "Name",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "email": {
      "id": "email",
      "label": "Email",
      "kind": "text",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "source": {
      "id": "source",
      "label": "Source",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in"
      ],
      "labels": null,
      "field": null
    },
    "createdAt": {
      "id": "createdAt",
      "label": "Added",
      "kind": "timestamp",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "before",
        "after",
        "between",
        "relative",
        "age",
        "empty"
      ],
      "labels": null,
      "field": null
    }
  }
} as const)
export type PendingUsersGridQuery = DataGridQuery<typeof pendingUsersGridContract>
export type PendingUsersGridResponse = DataGridResponse<typeof pendingUsersGridContract>

export type ReportsGridValues = {
  "reportDefinitionId": string
  "name": string
  "description": string
  "kind": string
  "updatedAt": string
  "canDelete": boolean
}
export const reportsGridContract = defineDataGridContract<ReportsGridValues>()({
  "id": "reports",
  "keyColumn": "reportDefinitionId",
  "searchMinimumLength": 3,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "name",
      "direction": "asc"
    }
  ],
  "columns": {
    "reportDefinitionId": {
      "id": "reportDefinitionId",
      "label": "Report ID",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "name": {
      "id": "name",
      "label": "Name",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "description": {
      "id": "description",
      "label": "Description",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "kind": {
      "id": "kind",
      "label": "Kind",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in",
        "empty"
      ],
      "labels": {
        "sql": "SQL",
        "structured": "Visual"
      },
      "field": null
    },
    "updatedAt": {
      "id": "updatedAt",
      "label": "Modified",
      "kind": "timestamp",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "before",
        "after",
        "between",
        "relative",
        "age",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "canDelete": {
      "id": "canDelete",
      "label": "Can delete",
      "kind": "value",
      "nullable": false,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    }
  },
  "parameters": {
    "createdByMe": {
      "type": "boolean",
      "default": false,
      "id": "createdByMe",
      "label": "Created by me"
    },
    "favoritesOnly": {
      "type": "boolean",
      "default": false,
      "id": "favoritesOnly",
      "label": "Favorites"
    }
  }
} as const)
export type ReportsGridQuery = DataGridQuery<typeof reportsGridContract>
export type ReportsGridResponse = DataGridResponse<typeof reportsGridContract>

export type RoleAssignmentsGridValues = {
  "rowKey": string
  "entity": string
  "subject": string
  "subjectType": string
  "memberCount": number | null
  "entityId": string
  "subjectId": string
}
export const roleAssignmentsGridContract = defineDataGridContract<RoleAssignmentsGridValues>()({
  "id": "role-assignments",
  "keyColumn": "rowKey",
  "searchMinimumLength": 3,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "entity",
      "direction": "asc"
    }
  ],
  "columns": {
    "rowKey": {
      "id": "rowKey",
      "label": "Assignment",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "entity": {
      "id": "entity",
      "label": "Entity",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "subject": {
      "id": "subject",
      "label": "Subject",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "subjectType": {
      "id": "subjectType",
      "label": "Subject type",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [
        "in"
      ],
      "labels": {
        "user": "User",
        "machine": "Service account",
        "group": "Group"
      },
      "field": null
    },
    "memberCount": {
      "id": "memberCount",
      "label": "Members",
      "kind": "number",
      "nullable": true,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [
        "equals",
        "atLeast",
        "atMost",
        "between",
        "empty"
      ],
      "labels": null,
      "field": null
    }
  },
  "supportingValues": {
    "entityId": {
      "kind": "value",
      "nullable": false
    },
    "subjectId": {
      "kind": "value",
      "nullable": false
    }
  }
} as const)
export type RoleAssignmentsGridQuery = DataGridQuery<typeof roleAssignmentsGridContract>
export type RoleAssignmentsGridResponse = DataGridResponse<typeof roleAssignmentsGridContract>

export type RolesGridValues = {
  "roleId": string
  "name": string
  "type": "System" | "Custom"
  "owner": string | null
  "description": string | null
  "permissions": number
}
export const rolesGridContract = defineDataGridContract<RolesGridValues>()({
  "id": "roles",
  "keyColumn": "roleId",
  "searchMinimumLength": 3,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "name",
      "direction": "asc"
    }
  ],
  "columns": {
    "roleId": {
      "id": "roleId",
      "label": "Role ID",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "name": {
      "id": "name",
      "label": "Name",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "type": {
      "id": "type",
      "label": "Type",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in"
      ],
      "labels": {
        "System": "System",
        "Custom": "Custom"
      },
      "field": null
    },
    "owner": {
      "id": "owner",
      "label": "Owner",
      "kind": "text",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "description": {
      "id": "description",
      "label": "Description",
      "kind": "text",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "permissions": {
      "id": "permissions",
      "label": "Permissions",
      "kind": "number",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "atLeast",
        "atMost",
        "between",
        "empty"
      ],
      "labels": null,
      "field": null
    }
  }
} as const)
export type RolesGridQuery = DataGridQuery<typeof rolesGridContract>
export type RolesGridResponse = DataGridResponse<typeof rolesGridContract>

export type ScimHistoryGridValues = {
  "requestId": string
  "operation": string
  "status": number
  "occurredAt": string
  "detail": string | null
  "scimType": string | null
  "correlationId": string
  "result": "Success" | "Warning" | "Error"
}
export const scimHistoryGridContract = defineDataGridContract<ScimHistoryGridValues>()({
  "id": "scim-history",
  "keyColumn": "requestId",
  "searchMinimumLength": 3,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "occurredAt",
      "direction": "desc"
    },
    {
      "column": "requestId",
      "direction": "desc"
    }
  ],
  "columns": {
    "requestId": {
      "id": "requestId",
      "label": "Request ID",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "operation": {
      "id": "operation",
      "label": "Operation",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "status": {
      "id": "status",
      "label": "HTTP result",
      "kind": "number",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "equals",
        "atLeast",
        "atMost",
        "between",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "occurredAt": {
      "id": "occurredAt",
      "label": "Occurred",
      "kind": "timestamp",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "between"
      ],
      "labels": null,
      "field": null
    },
    "detail": {
      "id": "detail",
      "label": "Detail",
      "kind": "text",
      "nullable": true,
      "searchable": true,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "scimType": {
      "id": "scimType",
      "label": "SCIM reason",
      "kind": "text",
      "nullable": true,
      "searchable": true,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "correlationId": {
      "id": "correlationId",
      "label": "Request",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "result": {
      "id": "result",
      "label": "Result",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": false,
      "filterable": true,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [
        "in"
      ],
      "labels": {
        "Success": "Success",
        "Warning": "Warning",
        "Error": "Error"
      },
      "field": null
    }
  }
} as const)
export type ScimHistoryGridQuery = DataGridQuery<typeof scimHistoryGridContract>
export type ScimHistoryGridResponse = DataGridResponse<typeof scimHistoryGridContract>

export type ServiceAccountsGridValues = {
  "userId": string
  "name": string
  "description": string | null
  "accessibleEntityCount": number
}
export const serviceAccountsGridContract = defineDataGridContract<ServiceAccountsGridValues>()({
  "id": "service-accounts",
  "keyColumn": "userId",
  "searchMinimumLength": 3,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "name",
      "direction": "asc"
    }
  ],
  "columns": {
    "userId": {
      "id": "userId",
      "label": "User ID",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "name": {
      "id": "name",
      "label": "Name",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "description": {
      "id": "description",
      "label": "Description",
      "kind": "text",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "accessibleEntityCount": {
      "id": "accessibleEntityCount",
      "label": "Access to",
      "kind": "number",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "atLeast",
        "atMost",
        "between",
        "empty"
      ],
      "labels": null,
      "field": null
    }
  }
} as const)
export type ServiceAccountsGridQuery = DataGridQuery<typeof serviceAccountsGridContract>
export type ServiceAccountsGridResponse = DataGridResponse<typeof serviceAccountsGridContract>

export type SettingHistoryGridValues = {
  "id": string
  "change": string
  "actor": string
  "source": string
  "timestamp": string
  "detail": string
  "sourceEntity": string | null
}
export const settingHistoryGridContract = defineDataGridContract<SettingHistoryGridValues>()({
  "id": "setting-history",
  "keyColumn": "id",
  "searchMinimumLength": 1,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "timestamp",
      "direction": "desc"
    }
  ],
  "columns": {
    "id": {
      "id": "id",
      "label": "Id",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "change": {
      "id": "change",
      "label": "Change",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "actor": {
      "id": "actor",
      "label": "Changed by",
      "kind": "category",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "in"
      ],
      "labels": null,
      "field": null
    },
    "source": {
      "id": "source",
      "label": "Source",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in"
      ],
      "labels": {
        "local": "This entity",
        "inherited": "Inherited"
      },
      "field": null
    },
    "timestamp": {
      "id": "timestamp",
      "label": "When",
      "kind": "timestamp",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "before",
        "after",
        "between",
        "relative",
        "age",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "detail": {
      "id": "detail",
      "label": "Detail",
      "kind": "value",
      "nullable": false,
      "searchable": false,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    }
  },
  "supportingValues": {
    "sourceEntity": {
      "kind": "text",
      "nullable": true
    }
  }
} as const)
export type SettingHistoryGridQuery = DataGridQuery<typeof settingHistoryGridContract>
export type SettingHistoryGridResponse = DataGridResponse<typeof settingHistoryGridContract>

export type UnrecognizedAssetsGridValues = {
  "groupKey": string
  "deviceHostname": string | null
  "deviceClass": string | null
  "manufacturer": string | null
  "ipAddress": string
  "macAddress": string
  "agentHostname": string | null
  "lastObservedAt": string
  "status": string
}
export const unrecognizedAssetsGridContract = defineDataGridContract<UnrecognizedAssetsGridValues>()({
  "id": "unrecognized-assets",
  "keyColumn": "groupKey",
  "searchMinimumLength": 3,
  "searchMode": "fuzzy",
  "defaultSort": [
    {
      "column": "lastObservedAt",
      "direction": "desc"
    }
  ],
  "columns": {
    "groupKey": {
      "id": "groupKey",
      "label": "Group key",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "deviceHostname": {
      "id": "deviceHostname",
      "label": "Device",
      "kind": "text",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "deviceClass": {
      "id": "deviceClass",
      "label": "Device type",
      "kind": "category",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "manufacturer": {
      "id": "manufacturer",
      "label": "Manufacturer",
      "kind": "category",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "ipAddress": {
      "id": "ipAddress",
      "label": "IP address",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "macAddress": {
      "id": "macAddress",
      "label": "MAC address",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "agentHostname": {
      "id": "agentHostname",
      "label": "Observed by",
      "kind": "category",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "lastObservedAt": {
      "id": "lastObservedAt",
      "label": "Last observed",
      "kind": "timestamp",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "before",
        "after",
        "between",
        "relative",
        "age",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "status": {
      "id": "status",
      "label": "State",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in"
      ],
      "labels": {
        "pending": "Pending",
        "provisional": "Provisional",
        "conflict": "Conflict"
      },
      "field": null
    }
  }
} as const)
export type UnrecognizedAssetsGridQuery = DataGridQuery<typeof unrecognizedAssetsGridContract>
export type UnrecognizedAssetsGridResponse = DataGridResponse<typeof unrecognizedAssetsGridContract>

export type UsersGridValues = {
  "userId": string
  "name": string
  "email": string | null
  "status": "Active" | "Deactivated"
  "access": string
  "accessibleEntityCount": number
  "source": string
  "title": string | null
  "department": string | null
  "hasDirectGrant": boolean
  "grantsJson": string
}
export const usersGridContract = defineDataGridContract<UsersGridValues>()({
  "id": "users",
  "keyColumn": "userId",
  "searchMinimumLength": 3,
  "searchMode": "contains",
  "defaultSort": [
    {
      "column": "name",
      "direction": "asc"
    }
  ],
  "columns": {
    "userId": {
      "id": "userId",
      "label": "User ID",
      "kind": "text",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": false,
      "hiddenByDefault": true,
      "alwaysSelected": true,
      "operators": [],
      "labels": null,
      "field": null
    },
    "name": {
      "id": "name",
      "label": "Name",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": true,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "email": {
      "id": "email",
      "label": "Email",
      "kind": "text",
      "nullable": true,
      "searchable": true,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "labels": null,
      "field": null
    },
    "status": {
      "id": "status",
      "label": "Status",
      "kind": "category",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "in"
      ],
      "labels": {
        "Active": "Active",
        "Deactivated": "Deactivated"
      },
      "field": null
    },
    "access": {
      "id": "access",
      "label": "Access",
      "kind": "text",
      "nullable": false,
      "searchable": true,
      "sortable": false,
      "filterable": false,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [],
      "labels": null,
      "field": null
    },
    "accessibleEntityCount": {
      "id": "accessibleEntityCount",
      "label": "Access to",
      "kind": "number",
      "nullable": false,
      "searchable": false,
      "sortable": true,
      "filterable": true,
      "hiddenByDefault": false,
      "alwaysSelected": false,
      "operators": [
        "equals",
        "atLeast",
        "atMost",
        "between",
        "empty"
      ],
      "labels": null,
      "field": null
    }
  },
  "supportingValues": {
    "source": {
      "kind": "text",
      "nullable": false
    },
    "title": {
      "kind": "text",
      "nullable": true
    },
    "department": {
      "kind": "text",
      "nullable": true
    },
    "hasDirectGrant": {
      "kind": "value",
      "nullable": false
    },
    "grantsJson": {
      "kind": "text",
      "nullable": false
    }
  },
  "parameters": {
    "includeDeactivated": {
      "type": "boolean",
      "default": false,
      "id": "includeDeactivated",
      "label": "Include deactivated"
    }
  }
} as const)
export type UsersGridQuery = DataGridQuery<typeof usersGridContract>
export type UsersGridResponse = DataGridResponse<typeof usersGridContract>
